export default {
  state: {
    urlQuery: null,
    // isLoginPayroll: false
    selectedPermList: null,
    permQueueIndex: 0
  },
  mutations: {
    setOvertimePageQuery(state, payload) {
      state.urlQuery = payload
    },
    setOvertimeQueue(state, payload) {
      state.selectedOvertimeList = payload.list
      state.overtimeQueueIndex = payload.index
    }
  },
  actions: {},
  getters: {
    getOvertimePageQuery(state) {
      return state.urlQuery
    },
    getOvertimeList(state) {
      return {
        list: state.selectedOvertimeList,
        index: state.overtimeQueueIndex
      }
    }
  }
}
